/**
 * @Desription: 登录
 * @Author: netstar.sjj
 * @Date: 2021-10-25 16:05:00
 * @class NSLogin
*/
declare const window:any;
import configManager from './config-manager';//config配置管理项
import controllerManager from './controller-manager';//方法管理
import disablePassword from './disable-password';//禁止密码自动填充
import loginManager from './login-manager';//登录管理
namespace NSLogin{
    const configManger = configManager;
    const controllerManger = controllerManager;
    const disabledPassWordFunc = disablePassword;
    export const loginManger = loginManager;
    export const toHomePage = controllerManager.toHomePage;
    export const registerManager = {
        init:function(_config:any){
            if(typeof(_config.registerConfig)=='object' && _config.registerId){
                if(_config.registerConfig.name){
                    if(_config.registerConfig.type === 'page'){
                        const blankUrl:string = document.location.href+'web/pages/register/reg.html';
                        window.jQuery('#'+_config.registerId).html('<a href="'+blankUrl+'" target="_blank" class="regist">'+_config.registerConfig.name+'</a>');
                    }else{
                        window.jQuery('#'+_config.registerId).html('<a href="javascript:void(0);" class="regist">'+_config.registerConfig.name+'</a>');
                        window.jQuery('#'+_config.registerId).off('click');
                        window.jQuery('#'+_config.registerId).on('click',{data:_config.registerConfig},function(aEvent:any){
                            var _registerConfig = aEvent.data.data;
                            switch(_registerConfig.type){
                                case 'page':
                                    //window.location.href = document.location.href+'pages/register/reg.html';
                                    break;
                                case 'dialog':
                                    break;
                                case 'code':
                                    break;
                                default:
                                    break;
                            }
                        });
                    }
                }
            }
        }
    };
    export let config:any = {};//当前全局运行的config
    export const serverData:any = {};
    export function getLoginProperty(res:any){
        if (typeof (res) === 'undefined') { res = {data: {}}; }
        const userInfoConfig:any = typeof (res.data.user) === 'object' ? res.data.user : {};
        userInfoConfig.userId = userInfoConfig.userId ? userInfoConfig.userId : userInfoConfig.id ;
        const contextConfig:any = typeof (res.data.context) === 'object' ? res.data.context : {};
        /** ********修改webapi地址：如果登录时使用了?nsserver定义了webapi地址 则修改webapi地址 start**************** */
        const resetServerUrl:string = window.NSUtils.resetServerUrl.get();
        if (resetServerUrl) {
            contextConfig.weburl = resetServerUrl;
        }
        /** ********修改webapi地址：如果登录时使用了?nsserver定义了webapi地址 则修改webapi地址 end**************** */
        return{
            config: userInfoConfig,
            systemInfo: {
                user: userInfoConfig,
                context: contextConfig,
                applyParams: {},
            },
        };
    }
    export function resetLoginFormByUrl(){
        let urlParas:any = window.NSUtils.getUrlPara();
        let loginObj:any = {};
        if(urlParas.orgname){
            let orgNameStr:string = decodeURIComponent(urlParas.orgname);
            //如果有简写的能匹配则使用简写的
            if(config.orgValues[urlParas.orgname]){
                orgNameStr = config.orgValues[urlParas.orgname];
            }
            loginObj.orgname = decodeURIComponent(orgNameStr);
        }
        if(urlParas.username){
            loginObj.username = decodeURIComponent(urlParas.username);
        }
        if(urlParas.password){
            loginObj.password = decodeURIComponent(urlParas.password);
        }
        if(window.jQuery.isEmptyObject(loginObj) == false){
            setTimeout(function(){
                if(loginObj.orgname){
                    window.jQuery(config.orgnameEl).val(loginObj.orgname);
                    window.jQuery(config.orgnameEl).parent().addClass('hide');
                }
                if(loginObj.username){
                    window.jQuery(config.usernameEl).val(loginObj.username);
                }
                if(loginObj.password){
                    window.jQuery(config.passwordEl).val(loginObj.password);
                }
            },100)
        }
    }
    //ajax登录失败
    export const ajaxError = function(errorRes:any) {
        let errorInfo:string = '';
        let config:any = window.NSLogin.config;
        //优先使用服务器端返回的错误信息
        if(errorRes.responseJSON){
            if(typeof(errorRes.responseJSON.msg) == 'string'){
                errorInfo = errorRes.responseJSON.msg;
            }
        }
        //未返回服务器定义的错误信息，则使用错误代码
        if(errorInfo == ''){
            let ajaxErrorInfo:any = window.NSLanguage.language.ajaxErrorInfo;
            if (typeof (ajaxErrorInfo.detail[errorRes.status]) == "string") {
                errorInfo = ajaxErrorInfo.detail[errorRes.status];
            } else {
                errorInfo = window.language.requestAjax.error + errorRes.status + "。";
            }
            errorInfo = typeof (ajaxErrorInfo.detail[errorRes.status]) == "string" ? ajaxErrorInfo.detail[errorRes.status] : ajaxErrorInfo.default[errorRes.status];
        }
        window.jQuery(config.msgEl).html(errorInfo);
        window.jQuery(config.msgEl).removeClass('hide');
        config.$login.removeClass('login-loading');
    }
    export function getConfirmHtml(titleStr:string){
        return '<div class="ns-confirm-container warning" id="nsconfirm-modal-default-login" tabindex="-1">'
                    +'<div class="confirm-body">'
                        +'<div class="confirm-content">'+titleStr+'</div>'
                    +'</div>'
                    +'<div class="confirm-footer">'
                        +'<div class="btn-group">'
                            +'<button type="button" class="btn btn-success" ns-confirm-type="confirm" fid="0"><i class="fa-check"></i><span>'+window.language.common.nsalert.determine+'</span></button>'
                            +'<button type="button" class="btn btn-white" ns-confirm-type="cancel" fid="1"><i class="fa-ban"></i><span>'+window.language.common.nsalert.cancel+'</span></button>'
                            +'</div>'
                        +'</div>'
                    +'<div class="confrim-bg"></div>'
                +'</div>';                         
    }

    export function clearQQMapStore(){
        let allStore = window.store.getAll();
        for(let key in allStore){
            if(key.indexOf("QMAPI") == 0){
                window.store.remove(key);
            }
        }
    };
    //初始化
    export function init(config:any){
        clearQQMapStore();
        config.images = typeof(config.images)=='object' ? config.images : {};
        if(typeof(window.NetstarApiConfig)=='object'){
            if(typeof(window.NetstarApiConfig.login)=='object'){
                if(typeof(window.NetstarApiConfig.login.register)=='object'){
                    config.registerConfig = window.NetstarApiConfig.login.register;
                }
                if(window.NetstarApiConfig.login.shortcutIconUrl){
                    const shortcutIconUrlLink = '<link rel="shortcut icon" type="image/vnd.microsoft.icon" href="'+window.NetstarApiConfig.login.shortcutIconUrl+'">';
                    window.jQuery('head').append(shortcutIconUrlLink);
                }
                if(window.NetstarApiConfig.login.title){
                    window.jQuery('title').html(window.NetstarApiConfig.login.title);
                    window.jQuery('[name="description"]').attr('content',window.NetstarApiConfig.login.title);
                }
                if(window.NetstarApiConfig.login.orgName){
                    window.jQuery(config.orgnameEl).attr('type','hidden');
                    window.jQuery(config.orgnameEl).val(window.NetstarApiConfig.login.orgName);
                    window.jQuery(config.orgnameEl).parent().addClass('hide');
                }
                if(window.NetstarApiConfig.login.orgnameEl === false){
                    window.jQuery(config.orgnameEl).attr('type','hidden');
                    window.jQuery(config.orgnameEl).parent().addClass('hide');
                }
                if(window.NetstarApiConfig.login.version){
                    config.version = window.NetstarApiConfig.login.version;//版本号
                }
                if(typeof(window.NetstarApiConfig.login.expireMinute)=='number'){
                    config.expireMinute = window.NetstarApiConfig.login.expireMinute;
                }
                if(typeof(window.NetstarApiConfig.login.images)=='object'){
                    if(window.NetstarApiConfig.login.images.logo){
                        config.images.logo = window.NetstarApiConfig.login.images.logo;
                    }
                    if(window.NetstarApiConfig.login.images.bg){
                        config.images.bg = window.NetstarApiConfig.login.images.bg;
                    }
                }
                if(window.NetstarApiConfig.login.footerContent && config.footerEl){
                    if(window.jQuery(config.footerEl).length === 1){
                        window.jQuery(config.footerEl).html(window.NetstarApiConfig.login.footerContent);
                    }
                }
            }
        }
        if(typeof(window.NSSystemConfig)=='object'){
            if(typeof(window.NSSystemConfig.login)=='object'){
                config.loginAjax = window.NSSystemConfig.login.ajax;//登录接口
            }
            if(typeof(window.NSSystemConfig.dicts)=='object'){
                config.getDict = window.NSSystemConfig.dicts.ajax;//字典接口
            }
            if(typeof(window.NSSystemConfig.menus)=='object'){
                for(let menuKeyI in window.NSSystemConfig.menus){
                    config.mainMenus[menuKeyI] = window.NSSystemConfig.menus[menuKeyI];
                }
            }
        }
        configManger.setDefault(config);//默认配置管理项
        this.config = config;

        let storeConfigStr = JSON.stringify(config);
        window.store.set('NetstarLoginConfig', storeConfigStr);
        
        let authCode:any = window.NSUtils.OAuthCode.get();
        if(authCode != false){
            config.$login.addClass('login-loading');//当前登录界面处于加载中
            controllerManger.toHomePage(authCode);//登录信息没有过期 不需要登录直接跳转到主界面
        }else{
            registerManager.init(config);
            disabledPassWordFunc(config);//禁止密码自动填充
            controllerManger.sso(config); //如果有?token=123则自动登录
            loginManger.init();//初始化欢迎界面
            resetLoginFormByUrl(); 
        }
        if(window.NetstarApiConfig.rememberUser){
            if(window.store.get("userInfo")){
                window.jQuery("#orgname").val(window.store.get("userInfo").orgName);
                window.jQuery("#username").val(window.store.get("userInfo").userName);
                window.jQuery("#password").val(window.store.get("userInfo").password);
            }
        }
    }
}
export default NSLogin;